import React, { useMemo } from 'react';
import {
  Box,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import { setSettings } from '../../../../support/slices/tileBuilderSlice';
import { ChartControlProps, COLOR_SCHEMES } from './ChartControlProps';
import { parsePaletteText, formatPaletteText } from '../../../../support/chartColorUtils';

const ChartColorsControls: React.FC<ChartControlProps> = ({ chartId, settings, dispatch }) => {
  const s: any = settings as any;

  const useCategorical = s.useCategorical !== false;
  const paletteText = useMemo(() => formatPaletteText(s.colors), [s.colors]);
  const enableCustomColorsUI = !useCategorical;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
      <Typography variant="subtitle2" sx={{ width: '100%' }}>
        Colors
      </Typography>

      <FormControlLabel
        control={
          <Switch
            checked={useCategorical}
            onChange={(e) => {
              const checked = e.target.checked;

              if (checked) {
                dispatch(
                  setSettings({
                    chartId,
                    settings: {
                      useCategorical: true,
                      colors: [],
                      colorScheme: 'nivo',
                      seriesColors: {},
                    } as any,
                  })
                );
              } else {
                dispatch(
                  setSettings({
                    chartId,
                    settings: {
                      useCategorical: false,
                    } as any,
                  })
                );
              }
            }}
          />
        }
        label="Use Magnetic (categorical) mode"
      />

      <FormControl sx={{ minWidth: 220 }} size="small" disabled={!enableCustomColorsUI}>
        <InputLabel>Color Scheme</InputLabel>
        <Select
          label="Color Scheme"
          value={s.colorScheme ?? 'nivo'}
          onChange={(e) =>
            dispatch(
              setSettings({
                chartId,
                settings: {
                  colorScheme: e.target.value as any,
                } as any,
              })
            )
          }
        >
          {COLOR_SCHEMES.map((scheme) => (
            <MenuItem key={scheme.value} value={scheme.value}>
              {scheme.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        label="Palette (comma-separated; overrides scheme)"
        size="small"
        value={paletteText}
        disabled={!enableCustomColorsUI}
        onChange={(e) =>
          dispatch(
            setSettings({
              chartId,
              settings: {
                colors: parsePaletteText(e.target.value),
              } as any,
            })
          )
        }
        sx={{ minWidth: 420, flex: '1 1 420px' }}
        placeholder="#1f77b4, #ff7f0e, #2ca02c"
        helperText={
          enableCustomColorsUI
            ? 'Palette overrides scheme. Leave empty to use scheme.'
            : 'Magnetic mode controls both chart and legend colors automatically.'
        }
      />
    </Box>
  );
};

export default ChartColorsControls;